export const TripPackageConfig: any = {
	fetchConfig: {
		with_relations: 'destinations,categories,tripServiceCatalogItems,domain',
		with_attributes: 'language_contents',
	},
	datasetRoute: '/detail/trip_packages/'
};
